import { useUIDSeed } from 'react-uid';
export default function useUniqueId(prefix, shouldRenderId) {
  const seed = useUIDSeed();
  return shouldRenderId ? `${seed(prefix)}` : undefined;
}